import React, { useState } from "react";
import "./Who_We_Are.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import InquiryFormModal from "../../common_components/InquiryFormModal/InquiryFormModal";

const Who_We_Are = () => {
  const [modalshow, setmodalshow] = useState(false);

  return (
    <section className="Who_we_are_sec">
      <div className="container">
        <div className="who-we-are-inner">
          <div className="who-we-are-main">
            <div className="who-we-are-image-col">
              <div className="img-sec">
                <img
                  className="studentimg"
                  src="/assets/images/home/who-we-are/dypatil.png"
                  alt="Dr. D.Y. Patil University"
                />
              </div>
            </div>

            <div className="who-we-are-content-col">
              <div className="content-sec">
                <div className="text-left">
                  <h3 className="commontitle">Discover Who We Are?</h3>

                  <p className="commonsubtitle">
                    India’s Leading Online Deemed-to-be University
                  </p>
                </div>

                <p className="abt_dpu">
                  At Dr. D.Y. Patil Vidyapeeth's Centre for Online Learning
                  (DPU-COL), we’re redefining education through innovative,
                  industry-aligned online programs. Designed by experts &amp;
                  backed by top accreditations, our courses offer globally
                  recognized, career-focused learning that connects academic
                  excellence with real-world success.
                </p>

                <div className="university-features">
                  <div className="university-feature-item">
                    <div className="flexuni">
                      <div className="icondiv">
                        <img
                          className="icon"
                          src="/assets/images/home/who-we-are/university.png"
                          alt=""
                        />
                      </div>

                      <div className="textdiv">
                        <p>University Mission Statement</p>
                      </div>
                    </div>
                  </div>

                  <div className="university-feature-item">
                    <div className="flexuni">
                      <div className="icondiv">
                        <img
                          className="icon"
                          src="/assets/images/home/who-we-are/school.png"
                          alt=""
                        />
                      </div>

                      <div className="textdiv">
                        <p>University Vision Achievement</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="ranked_div">
            <div className="ranked-item bd-right">
              <h1>Ranked #1</h1>
              <p>Among Online &amp; Distance Learning Institutes</p>
            </div>

            <div className="ranked-item">
              <h1>40 Years</h1>
              <p>of Consistent Excellence</p>
            </div>
          </div>

          <div className="btn_holder">
            <button
              className="Red_Btn"
              type="button"
              onClick={() => setmodalshow(true)}
            >
              <p className="btn_text">Enquire Now</p>

              <div className="icon_holder">
                <FontAwesomeIcon icon={faArrowRight} className="icon" />
              </div>
            </button>
          </div>
        </div>
      </div>

      <InquiryFormModal
        show={modalshow}
        onHide={() => setmodalshow(false)}
        setmodalshow={setmodalshow}
        modalshow={modalshow}
      />
    </section>
  );
};

export default Who_We_Are;
